import * as React from "react"
import { useMemo } from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

import { useAdminSkuToolbar } from "../@hooks"


export default function AdminSkuTableToolbarSelect({ selectedData, setSelectedRows }) {
    const selectedIDs = useMemo(() => {
        return selectedData.map(({ skuID }) => skuID)
    }, [JSON.stringify(selectedData)])

    const { handleToolbar } = useAdminSkuToolbar(selectedIDs, setSelectedRows)

    return <Box display="flex" gap={.5}>
        <ButtonIconSeeker
            icon="code-merge"
            tooltip={`Merge ${selectedIDs.length} SKUs`}
            onClick={() => handleToolbar(selectedIDs.length)}
        />
    </Box>
}